import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files directly
import enTranslations from "./locales/en.json";
import deTranslations from "./locales/de.json";

i18n
  .use(LanguageDetector) // Detect browser language
  .use(initReactI18next) // Bind with React
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      de: {
        translation: deTranslations
      }
    },
    fallbackLng: "en", // Default language
    supportedLngs: ["en", "de"], // List of supported languages
    debug: false, // Disable debug mode in production
    interpolation: {
      escapeValue: false, // React already handles escaping
    },
  });

export default i18n;